export const BOOK_SLOT = 'BOOK_SLOT';
export const CHANGE_QUANTITY = 'CHANGE_QUANTITY';
export const CHANGE_SLOT_DATE = 'CHANGE_SLOT_DATE';
export const CHANGE_SLOT_TYPE = 'CHANGE_SLOT_TYPE';
export const REMOVE_ITEM = 'REMOVE_ITEM';

export const HARD_TYPE = 'HARD';
export const SOFT_TYPE = 'SOFT';
